import Gauge from '@/components/Gauge';
import { toFactor } from '@/utilities/formatting';

export interface Props {
  portfolioPEG: number;
  portfolioName: string;
  marketPEG: number;
  marketName: string;
}

const keys = ['portfolio', 'market'];

const PEGRatioGauge = ({
  portfolioPEG,
  portfolioName,
  marketPEG,
  marketName,
}: Props) => {
  const entities = {
    [keys[0]]: portfolioPEG,
    [keys[1]]: marketPEG,
  };
  const entityTitles = {
    [keys[0]]: portfolioName,
    [keys[1]]: marketName,
  };
  return (
    <Gauge
      title="PEG Ratio"
      keys={keys}
      entityTitles={entityTitles}
      entities={entities}
      formatter={(value: number | null) =>
        value !== null ? toFactor(value, 1) : 'n/a'
      }
      numTicks={5}
      from={0}
      to={4}
      flip={true}
    />
  );
};

export default PEGRatioGauge;
